/* React 18 deprecates ReactDOM.findDOMNode; React 19 removes it entirely.
   @noriginmedia/react-spatial-navigation@2.12.9 (unmaintained) calls
   ReactDOM.findDOMNode(this) in its withFocusable lifecycle (componentDidMount /
   componentDidUpdate) to hand the DOM node to the layout engine.

   Polyfill the behaviour without the deprecation warning: for class instances we
   walk the private `_reactInternals` fiber to the first host node — the same
   resolution React's own findHostInstanceWithWarning performs. Imported from
   src/index.jsx before render so every call site (the lib's included) hits the
   patched export, since react-dom is a single shared module in the bundle. */
import ReactDOM from 'react-dom';

/* eslint-disable no-underscore-dangle -- need React's private fiber to resolve the host node */
if (typeof ReactDOM.findDOMNode === 'function' && !ReactDOM.findDOMNode.__dtvCompat) {
  const originalFindDOMNode = ReactDOM.findDOMNode;

  const findDOMNodeCompat = function findDOMNodeCompat(componentOrElement) {
    if (!componentOrElement) {
      return undefined;
    }
    if (componentOrElement.nodeType === 1) { // ELEMENT_NODE
      return componentOrElement;
    }
    let fiber = componentOrElement._reactInternals;
    while (fiber) {
      const { stateNode } = fiber;
      if (stateNode && stateNode.nodeType === 1) {
        return stateNode;
      }
      fiber = fiber.child;
    }
    return originalFindDOMNode(componentOrElement);
  };

  findDOMNodeCompat.__dtvCompat = true;
  ReactDOM.findDOMNode = findDOMNodeCompat;
}
/* eslint-enable no-underscore-dangle -- private fiber access required */
